import $ from 'jquery';
import React from 'react';
import get from 'lodash/get';

// var GiphyAPI = require('./GiphyAPI.react');

class SearchBar extends React.Component {
	state = {
	  term: '',
	};

	onInputChange = (term) => {
	  this.setState({ term });
	  this.props.onTermChange(term);
	};

	render() {
	  return (
  <div className="search form-group mtxs">
    <input className="form-control" onChange={event => this.onInputChange(event.target.value)} placeholder={get(translations, 'txt: Meklēt GIF', '')} />
    <div className="giphy-watermark fr" />
  </div>
	  );
	}
}

module.exports = SearchBar;
